// extracted by mini-css-extract-plugin
export default {"container":"orders_container__CGcsX","list":"orders_list__UFv3Q","list__scroll":"orders_list__scroll__hZXwX","feed":"orders_feed__Ack5B"};